import actionTypes from "actions/actionTypes";

const initialState = {
  companies: [],
  isGhosting: false,
  ghostingCompany: ""
};

const changeRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_GHOSTING_COMPANIES:
      return {
        ...state,
        companies: action.payload
      };
    case actionTypes.IS_GHOSTING:
      return {
        ...state,
        isGhosting: action.payload
      };
      case actionTypes.SET_GHOSTING_COMPANY:
        return {
          ...state,
          ghostingCompany: action.payload
        };
    default:
      return state;
  }
};

export default changeRoleReducer;
